/* eslint-disable no-unused-vars */
import React, { memo, useState } from "react";
import { Card,Button,Col,Row,Form,Image,Modal} from "antd";
import { useLocation, useNavigate } from "react-router";
import CustomTable from "../../../components/CustomTable";
import messageToast from "../../../components/messageToast/messageToast";
import apis from "../../../api/stateAPI";

function OrlpcclaimapparmForm() {
  const { state } = useLocation();
  const [form] = Form.useForm();
  const [reason, setReason] = useState("");

  const [showModel, setShowModel] = useState(false);

  const cancelNavigation = () => {
    setShowModel(false);
  };

  const dateToYMD = (date) => {
    var strArray = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    var d = date.getDate();
    var m = strArray[date.getMonth()];
    var y = date.getFullYear();
    return "" + (d <= 9 ? "0" + d : d) + "-" + m + "-" + y;
  };
  let url = process.env.REACT_APP_API_BASE_URL;
  url = url.replace("api/", "");
  const data =
  state?.expense_data?.length > 0
    ? state.expense_data.map((e) => {        
        let S_No = e.id;
        let Expense_Date = e.expense_date;
        let Expense_Type = e.expense_type;
        let Request_Amount = e.amount;
        let Approved_Amount = e.approved_amount;
        let Reason = e.remark;
        let select = '<input type="checkbox" name="vehicle1" value="Bike">';

        // Ensure bill_copy is processed correctly
        let Bill_Copy = e.bill_copy
          ? e.bill_copy.split(",").map((file) => `${state?.pathfor_attachments}${file.trim()}`)
          : [];      
        return {
          ...e,
          S_No,
          Expense_Date,
          Expense_Type,
          Request_Amount,
          Approved_Amount,
          Reason,
          Bill_Copy,
          select,
        };
      })
    : [];


  const navigate = useNavigate();

  const onClickAdd = () => {
    navigate("/orlpcclaimapparmForm");
  };

  const handleViewClick = (rowInfo) => {
    navigate("/orlpcclaimapparmForm", {
      state: rowInfo,
    });
  };
 

  const currentDate = new Date().toISOString().split("T")[0]; 
  
  const handleApprovel = () => {
    let data = {
      id: state?.id,
      submission_date: state?.submission_date, 
      status:
        state?.ticketstatus == "Waiting @ Back Office"
          ? "Waiting @ AH Approval"
          : "Waiting @ Back Office",
    };

    apis.updatePettyCashRequestData(data).then((res) => {
      if (res.data?.status === 200) {
        messageToast({
          message: res?.data?.statusText,
          status: res?.data?.status,
          title: "Payment Request",
        });
        if (state?.ticketstatus == "Waiting @ Back Office") {
          navigate("/orlpcclaimappbo");
        } else {
          navigate("/orlpcclaimapparm");
        }
      } else {
        messageToast({
          message: res?.data?.message ?? "Something went wrong",
          status: res?.data.status,
          title: "Payment Request",
        });
      }
    });
  };
  const handleReject = () => {
       if (reason) {
      let data = {
        id: state?.id,
        submission_date: currentDate, 
        status:
          state?.ticketstatus == "Waiting @ Back Office"
            ? "Waiting @ ARM"
            : "Rejected",
        rejected_reason: reason,
        rejected_by:
          state?.ticketstatus == "Waiting @ Back Office"
            ? "Back Office"
            : "ARM",
      };

      apis.updatePettyCashRequestData(data).then((res) => {
        if (res.data?.status === 200) {
           messageToast({
            message: res?.data?.statusText,
            status: res?.data?.status,
            title: "Payment Request",
          });
          if (state?.ticketstatus == "Waiting @ Back Office") {
            navigate("/orlpcclaimappbo");
          } else {
            navigate("/orlpcclaimapparm");
          }
        } else {
          messageToast({
            message: res?.data?.message ?? "Something went wrong",
            status: res?.data.status,
            title: "Payment Request",
          });
        }
      });
    } else {
      messageToast({
        message: "Please Enter the Reason",
        status: 400,
        title: "Payment Request",
      });
    }
  };

  let column = [
    { key: "1", headerName: "S.No", field: "S.No", hide: false, width: 70 },
    { key: "2", headerName: "Expense Date", field: "Expense_Date",hide: false,width: 150,},
    { key: "3", headerName: "Expense Type", field: "Expense_Type",hide: false,width: 180,},
    { key: "4", headerName: "Reason", field: "Reason",hide: false,width: 250,},
    { key: "5", headerName: "Request Amount", field: "Request_Amount",hide: false,width: 200,},
    { key: "6", headerName: "Approved Amount", field: "Approved_Amount",hide: false,width: 200,},
    {
      key: "7",
      headerName: "Bill Copy",
      field: "Bill_Copy",
      hide: false,
      width: 180,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", gap: "5px" }}>
            {Array.isArray(params.row.Bill_Copy) &&
              params.row.Bill_Copy.map((imgSrc, index) => (
                <Image
                  key={index}
                  src={imgSrc} 
                  width={50}
                  onError={(e) => { e.target.style.display = "none"; }}
                />
              ))}
          </div>
        );
      },
    },
   ];
  return (
    <>
      <div className="h-screen apphide lasthide">
        <Card>
          <Row>
            <Col span={24}>
              <Form
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}                          
                autoComplete="off"
              >
                <Row gutter={[15, 0]}>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <CustomTable
          showHeader={false}
          showEdit={false}
          dataSource={data}
          column={column}
          hideActionBtn={true}
          handleViewClick={handleViewClick}
          onClickAdd={onClickAdd}
          title={"Approval List"}
        />
        {state?.ticketstatus != "Waiting @ AH Approval" && (
          <Col
            span={12}
            style={{ textAlign: "center" }}
            className="d-flex align-items-center justify-content-end mt-3">
            <Form.Item className="mx-2">
              <Button
                className="orangeFactory"
                type="primary"
                htmlType="submit"
                onClick={() => {
                  handleApprovel();
                }}>
                Approved
              </Button>
            </Form.Item>
            {/* </Col>
                    <Col span={12}> */}
            <Form.Item>
              <Button
                onClick={() => {
                  setShowModel(true);
                }}>
                Reject
              </Button>
            </Form.Item>
          </Col>
        )}
      </div>

      <Modal
        open={showModel}
        width="40%"
        onOk={handleReject}
        okButtonProps={{ danger: "danger" }}
        onCancel={cancelNavigation}
        title={<span className="text-2xl text-red-600">Reject Reason?</span>}>
        <div className="text-lg text-gray-600">
          <input
            className="col-md-6"
            type="text"
            value={reason}
            onChange={(e) => {
              setReason(e?.target?.value);
            }}
            placeholder="reason"
          />         
        </div>
      </Modal>
    </>
  );
}

export default memo(OrlpcclaimapparmForm);
